import React from "react";
import { IconProps } from ".";

const UserIcon: React.FC<IconProps> = ({ size = "16", ...attributes }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...attributes}
    >
      <g clipPath="url(#clip0_376_9811)">
        <rect width="28" height="28" rx="8" fill="#D7E5FF" />
        <path
          d="M19.4131 10.5C19.4131 13.5376 16.9507 16 13.9131 16C10.8755 16 8.41309 13.5376 8.41309 10.5C8.41309 7.46243 10.8755 5 13.9131 5C16.9507 5 19.4131 7.46243 19.4131 10.5Z"
          fill="#222222"
        />
        <ellipse cx="14" cy="27" rx="15" ry="9" fill="#222222" />
      </g>
      <defs>
        <clipPath id="clip0_376_9811">
          <rect width="28" height="28" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UserIcon;
